import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function SplitIntro() {
  return <section className="py-16 px-6 md:px-20 bg-[#0A0A0A] border-t border-white/5" data-id="element-152">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="relative aspect-[4/5] overflow-hidden rounded-lg" data-id="element-154">
          <video src="https://cdn.magicpatterns.com/uploads/t1qVkb8BwQ3wZJCVS7hoD4/MicrosoftTeams-video%20(4).mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-155" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-156">
          <span className="text-[11px] font-montserrat font-bold tracking-[0.4em] text-[#992f74] uppercase" data-id="element-157">
            Sips and Nibblez
          </span>
          <h2 className="text-3xl md:text-4xl font-montserrat font-light tracking-wider leading-tight text-white" data-id="element-158">
            Luxury in Every Sip & Bite
          </h2>
          <div className="space-y-6 text-white/60 text-lg leading-relaxed font-light" data-id="element-159">
            <p data-id="element-160">
              At Sips and Nibblez by Zobug, we believe every event deserves a
              taste of luxury. From bespoke cocktails and mocktails to gourmet
              bites and desserts, our offerings are thoughtfully curated to
              delight your guests and elevate your celebration.
            </p>
            <p data-id="element-161">
              We blend creativity, premium ingredients, and top-tier
              presentation to deliver not just drinks and food — but a memorable
              experience that feels indulgent, fun, and effortlessly
              sophisticated. Because here, pour decisions always taste better.
            </p>
          </div>
          <div className="pt-4" data-id="element-162">
            <a href="/book" className="inline-block text-xs font-bold uppercase tracking-[0.3em] text-white border-b border-[#992f74] pb-2 hover:text-[#992f74] transition-colors" data-id="element-163">
              Book an Appointment &nbsp; &gt;
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}